<!-- <form (ngSubmit)="SaveItem()" #f="ngForm" class="mt-4 pl-2"> -->
  <form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="form-horizontal">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group row">
              <!-- <label class="col-form-label col-2"><span translate="OKRUG.NAZIV.SINGULAR"></span></label> -->
              <div class="col-md-12">
                <yt-input
                  [Type]="'text'"
                  name="txtNaziv"
                  formControlName="Naziv"
                  #focusElement
                  [MaxLength]="200"
                  [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
                  [Label]="'OKRUG.NAZIV.SINGULAR'"
                  >
                </yt-input>
                  <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                      <span *ngFor="let validation of errorMessages.Naziv">
                        <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                      </span>
                        <!-- <span *ngIf="fc.Naziv.errors.required">Naziv je obavezan podatak</span> -->
                    </div>
              </div>
            </div>
            <div class="form-group row">
                <!-- <label class="col-form-label col-2"><span translate="OKRUG.DRZAVAID.SINGULAR"></span></label> -->
                <div class="col-md-12">
                    <!-- <yt-fw-dropdown
                    [ModelName]="'drzava'"
                    [GetName]="'get'"
                    [ModelProperty]="'Naziv'"
                    [OrderBy]="'Naziv'"
                    [AllowAddNew]='true'
                    [Required]='true'
                    [Disabled]='false'
                    formControlName="DrzavaID"
                    name="cmbDrzava"
                    [Type]="ID"
                    [ngClass]="{'is-invalid': submitted && fc.DrzavaID.invalid}"
                    [Label]="'OKRUG.DRZAVAID.SINGULAR'"
                    >
                  </yt-fw-dropdown> -->
                  <yt-dropdown-picklist
                    [ModelName]="'drzava'"
                    [GetName]="'get'"
                    [ModelProperty]="'Naziv'"
                    [OrderBy]="'Naziv'"
                    [AllowAddNew]="true"
                    [AllowEdit]="true"
                    formControlName="DrzavaID"
                    [Label]="'OKRUG.DRZAVAID.SINGULAR'"
                    >
                  </yt-dropdown-picklist>
                  <div class="form-error" *ngIf="submitted && fc.DrzavaID.invalid">
                      <span *ngFor="let validation of errorMessages.DrzavaID">
                        <span class="error-message" *ngIf="fc.DrzavaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                      </span>
                        <!-- <span *ngIf="fc.Naziv.errors.required">Naziv je obavezan podatak</span> -->
                    </div>
                    <!-- <yt-multiselect
                      [ModelName]="'drzava'"
                      [GetName]="'get'"
                      [ModelProperty]="'Naziv'"
                      [OrderBy]="'Naziv'">
                    </yt-multiselect> -->
                </div>
            </div>
            <!-- <div class="form-group row">
              <div class="col-md-12">
                <yt-dropdown-picklist
                  [ModelName]="'drzava'"
                  [GetName]="'get'"
                  [ModelProperty]="'Naziv'"
                  [OrderBy]="'Naziv'"
                  [AllowAddNew]="false"
                  formControlName="DrzavaID"
                  [Label]="'OKRUG.DRZAVAID.SINGULAR'"
                  >
                </yt-dropdown-picklist>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-12">
                <yt-autocomplete
                  [ModelName]="'drzava'"
                  [GetName]="'get'"
                  [ModelProperty]="'Naziv'"
                  [OrderBy]="'Naziv'"
                  [AllowAddNew]="false"
                  formControlName="DrzavaID"
                  [Label]="'OKRUG.DRZAVAID.SINGULAR'">
                </yt-autocomplete>
              </div>
            </div> -->
        </div>
      </div>
    </div>
  </form>